import { render, staticRenderFns } from "./user-info-change-mail-address.vue?vue&type=template&id=6e62dcaa&scoped=true&"
import script from "./user-info-change-mail-address.vue?vue&type=script&lang=ts&"
export * from "./user-info-change-mail-address.vue?vue&type=script&lang=ts&"
import style0 from "./user-info-change-mail-address.vue?vue&type=style&index=0&id=6e62dcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62dcaa",
  null
  
)

export default component.exports